import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import PublicSite from '@/components/PublicSite';
import AdminApp from '@/components/sections/AdminApp';
import { Toaster } from '@/components/ui/toaster';
import ChatWidget from '@/components/ChatWidget';

// Layout wrapper for public pages
const PublicLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
};

// Layout wrapper for admin pages (no header/footer)
const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      {children}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <PublicLayout>
            <PublicSite />
          </PublicLayout>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin" element={
          <AdminLayout>
            <AdminApp />
          </AdminLayout>
        } />
        
        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      
      <Toaster />
    </BrowserRouter>
  );
}

export default App;